import { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAppDispatch } from '@/store';
import { setCredentials, clearCredentials } from '@/store/authSlice';
import { setAccessToken } from '@/lib/axios';
import { authApi } from '@/features/auth/auth.api';

export default function OAuthCallbackPage(): JSX.Element {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = params.get('token');
    if (!token) {
      dispatch(clearCredentials());
      navigate('/login?error=oauth', { replace: true });
      return;
    }
    setAccessToken(token);
    authApi
      .me()
      .then(({ user }) => {
        dispatch(setCredentials({ user, accessToken: token }));
        navigate('/dashboard', { replace: true });
      })
      .catch(() => {
        dispatch(clearCredentials());
        navigate('/login?error=oauth', { replace: true });
      });
  }, [params, navigate, dispatch]);

  return (
    <div className="flex min-h-full items-center justify-center">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-brand-600 border-t-transparent" />
    </div>
  );
}
